<template>
  <div class="bulk-action__container">
    <div class="flex-between">
      <div class="bulk-action__actions flex-between">
        <div
          v-tooltip="$t('BULK_ACTION.LABELS.ASSIGN_LABELS')"
          class="w-8 h-8 bg-white border border-gray-200 rounded-[4px] flex justify-center items-center cursor-pointer"
          @click="toggleLabelActions"
        >
          <span class="material-symbols-outlined text-base text-gray-500">
            shoppingmode
          </span>
        </div>
        <div
          v-tooltip="$t('BULK_ACTION.UPDATE.CHANGE_STATUS')"
          class="w-8 h-8 bg-white border border-gray-200 rounded-[4px] flex justify-center items-center cursor-pointer"
          @click="toggleUpdateActions"
        >
          <span class="material-symbols-outlined text-base text-gray-500">
            sync
          </span>
        </div>
        <div
          v-if="hasInboxPermission('Inbox can assign')"
          v-tooltip="$t('BULK_ACTION.ASSIGN_AGENT_TOOLTIP')"
          class="w-8 h-8 bg-white border border-gray-200 rounded-[4px] flex justify-center items-center cursor-pointer"
          @click="toggleAgentList"
        >
          <span class="material-symbols-outlined text-base text-gray-500">
            person_add
          </span>
        </div>
        <div
          v-tooltip="$t('BULK_ACTION.ASSIGN_TEAM_TOOLTIP')"
          class="w-8 h-8 bg-white border border-gray-200 rounded-[4px] flex justify-center items-center cursor-pointer"
          @click="toggleTeamsList"
        >
          <span class="material-symbols-outlined text-base text-gray-500">
            group_add
          </span>
        </div>
      </div>
      <transition name="popover-animation">
        <label-actions
          v-if="showLabelActions"
          class="label-actions-box"
          @assign="assignLabels"
          @close="showLabelActions = false"
        />
      </transition>
      <transition name="popover-animation">
        <update-actions
          v-if="showUpdateActions"
          class="update-actions-box"
          :selected-inboxes="selectedInboxes"
          :conversation-count="conversations.length"
          :show-resolve="!showResolvedAction"
          :show-reopen="!showOpenAction"
          :show-snooze="!showSnoozedAction"
          @update="updateConversations"
          @close="showUpdateActions = false"
        />
      </transition>
      <transition name="popover-animation">
        <agent-selector
          v-if="showAgentsList"
          class="agent-actions-box"
          :selected-inboxes="selectedInboxes"
          :conversation-count="conversations.length"
          @select="submit"
          @close="showAgentsList = false"
        />
      </transition>
      <transition name="popover-animation">
        <team-actions
          v-if="showTeamsList"
          class="team-actions-box"
          @assign-team="assignTeam"
          @close="showTeamsList = false"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import AgentSelector from './AgentSelector.vue';
import UpdateActions from './UpdateActions.vue';
import LabelActions from './LabelActions.vue';
import TeamActions from './TeamActions.vue';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';

export default {
  components: {
    AgentSelector,
    UpdateActions,
    LabelActions,
    TeamActions,
  },
  mixins: [hasPermissionMixin],
  props: {
    conversations: {
      type: Array,
      default: () => [],
    },
    allConversationsSelected: {
      type: Boolean,
      default: false,
    },
    selectedInboxes: {
      type: Array,
      default: () => [],
    },
    showOpenAction: {
      type: Boolean,
      default: false,
    },
    showResolvedAction: {
      type: Boolean,
      default: false,
    },
    showSnoozedAction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAgentsList: false,
      showUpdateActions: false,
      showLabelActions: false,
      showTeamsList: false,
      popoverPositions: {},
    };
  },
  methods: {
    selectAll(e) {
      this.$emit('select-all-conversations', e.target.checked);
    },
    submit(agent) {
      this.$emit('assign-agent', agent);
    },
    updateConversations(status) {
      this.$emit('update-conversations', status);
    },
    assignLabels(labels) {
      this.$emit('assign-labels', labels);
    },
    assignTeam(team) {
      this.$emit('assign-team', team);
    },
    resolveConversations() {
      this.$emit('resolve-conversations');
    },
    toggleUpdateActions() {
      this.showUpdateActions = !this.showUpdateActions;
    },
    toggleLabelActions() {
      this.showLabelActions = !this.showLabelActions;
    },
    toggleAgentList() {
      this.showAgentsList = !this.showAgentsList;
    },
    toggleTeamsList() {
      this.showTeamsList = !this.showTeamsList;
    },
  },
};
</script>

<style scoped lang="scss">
// For RTL direction view
.app-rtl--wrapper {
  .bulk-action__actions {
    ::v-deep .button--only-icon:last-child {
      margin-right: var(--space-smaller);
    }
  }
}

.bulk-action__actions {
  @apply flex gap-1;
}

.bulk-action__container {
  @apply relative;
}

.bulk-action__panel {
  @apply cursor-pointer;

  span {
    @apply text-xs my-0 mx-1;
  }

  input[type='checkbox'] {
    @apply cursor-pointer m-0;
  }
}

.popover-animation-enter-active,
.popover-animation-leave-active {
  transition: transform ease-out 0.1s;
}

.popover-animation-enter {
  transform: scale(0.95);
  @apply opacity-0;
}

.popover-animation-enter-to {
  transform: scale(1);
  @apply opacity-100;
}

.popover-animation-leave {
  transform: scale(1);
  @apply opacity-100;
}

.popover-animation-leave-to {
  transform: scale(0.95);
  @apply opacity-0;
}

.label-actions-box {
  --triangle-position: 6.3125rem;
}
.update-actions-box {
  --triangle-position: 4.2rem;
}
.agent-actions-box {
  --triangle-position: 2rem;
}
.team-actions-box {
  --triangle-position: 0rem;
}
</style>
